import { useQuery } from '@tanstack/react-query';
import { collectorsQueryOptions, memberInstitutesQueryOptions } from '../api/question.api';
import { DetailCard } from './DetailCard';

interface SelectionDetailCardsProps {
  memberId: number | undefined;
  instituteId: number | undefined;
  boardId: number | undefined;
}

export function SelectionDetailCards({
  memberId,
  instituteId,
  boardId,
}: SelectionDetailCardsProps) {
  const { data: collectors } = useQuery({
    ...collectorsQueryOptions(undefined, boardId),
    enabled: memberId !== undefined,
  });
  const { data: institutes } = useQuery(memberInstitutesQueryOptions(memberId));

  const member = collectors?.find((c) => c.userId === memberId);
  const institute = institutes?.find((i) => i.instituteId === instituteId);

  if (member === undefined && institute === undefined) return null;

  return (
    <div className="flex flex-wrap gap-3">
      {member === undefined ? null : (
        <DetailCard
          title="Zonal Manager"
          rows={[
            ['Name', member.fullName],
            ['Username', member.username],
            ['Designation', member.designationName],
            ['Mobile', member.mobile],
            ['HR ID', member.hrEmpId],
            ['Thana', member.thanaName],
            ['District', member.districtName],
          ]}
        />
      )}
      {institute === undefined ? null : (
        <DetailCard
          title="Institution"
          rows={[
            ['Name', institute.instituteName],
            ['Code', institute.instituteCode === null ? null : String(institute.instituteCode)],
            ['EIIN', institute.instituteEiin],
            ['Division', institute.divisionName],
            ['District', institute.districtName],
            ['Thana', institute.thanaName],
          ]}
        />
      )}
    </div>
  );
}
